document.addEventListener('DOMContentLoaded', function() {

  // Элементы
  const cards = document.querySelectorAll('.steps__card:not(.steps__card--empty)');
  const progressPoints = document.querySelectorAll('.steps__progress-point');
  const progressFill = document.querySelector('.steps__progress-fill');
  const stepsSection = document.getElementById('stages');

  // Текущий шаг
  let currentStep = 1;
  const totalSteps = cards.length;

  // Интервал для автоматического переключения
  let autoProgressInterval = null;

  // Функция для остановки автоматического переключения
  function stopAutoProgress() {

    if (autoProgressInterval) {
      clearInterval(autoProgressInterval);
      autoProgressInterval = null;
    }
  }

  // Функция для перехода к определенному шагу
  function goToStep(step) {
    // Проверяем границы
    if (step < 1) step = 1;
    if (step > totalSteps) step = totalSteps;

    // Обновляем карточки
    cards.forEach(card => {
      const cardStep = parseInt(card.getAttribute('data-step'));
      if (cardStep === step) {
        card.classList.add('active');
      } else {
        card.classList.remove('active');
      }
    });

    // Обновляем прогресс-бар
    progressPoints.forEach(point => {
      const pointStep = parseInt(point.getAttribute('data-step'));
      if (pointStep === step) {
        point.classList.add('active');
      } else {
        point.classList.remove('active');
      }
    });

    // Обновляем линию прогресс-бара
    updateProgressBar(step);

    // Обновляем текущий шаг
    currentStep = step;
  }

  // Обновить прогресс-бар
  function updateProgressBar(step) {
    if (progressFill) {
      const percentage = ((step - 1) / (totalSteps - 1)) * 100;
      progressFill.style.width = percentage + '%';
    }
  }

  // Функция автоматического переключения шагов
  function startAutoProgress() {


    // Если уже запущен интервал, останавливаем его
    stopAutoProgress();

    let step = 1;

    // Сначала показываем первый шаг
    goToStep(step);

    // Затем запускаем интервал
    autoProgressInterval = setInterval(() => {
      step++;
      if (step > totalSteps) {
        step = 1; // Начинаем снова с первого шага
      }

      goToStep(step);
    }, 1000); // Переключаем каждую секунду
  }

  // Проверка видимости секции
  function checkSectionVisibility() {
    if (!stepsSection) return;

    const rect = stepsSection.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

    if (isVisible && !autoProgressInterval) {
      // Запускаем авто-переключение с задержкой
      setTimeout(() => {
        startAutoProgress();
      }, 1000);
    } else if (!isVisible && autoProgressInterval) {
      stopAutoProgress();
    }
  }

  // Слушаем скролл для проверки видимости
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(checkSectionVisibility, 100);
  });

  // Проверяем видимость при загрузке
  setTimeout(checkSectionVisibility, 500);

  // Инициализация
  goToStep(currentStep);
});
